export default __webpack_public_path__ + "static/media/boots_of_the_wicked.b6fc6d71.jpg";